import ngRedux from 'ng-redux'
import { PROMO_CODE_ADDED } from '../sale-model.constant'
import { $rootScope } from '../../../ng-compat/imports'
import { RootState } from '../../../state/store'
import { selectSalePromoCode } from '../../../state/slices/currentSale/currentSaleSlice'
import { SaleManager } from '../../../managers/sale-manager'
import { SalePromotionPopoverController } from './sale-promotion-popover.controller'
import template from './sale-promotion-popover.html'

/**
 * Controller for the sale-promotion component.
 *
 * @class SalePromotionController
 */
export class SalePromotionController {
  public unbindPromoAdded: () => void
  public promoCode: string = ''
  private unSubsribeToRedux: () => void
  constructor(
    private $element: JQLite,
    private vdPopover: $TSFixMe,
    private readonly $ngRedux: ngRedux.INgRedux,
    public saleManager: SaleManager
  ) {
    'ngInject'
    this.unbindPromoAdded = $rootScope.$on(PROMO_CODE_ADDED, () => {
      if (this.promoCode) {
        this.togglePromotionPopover()
      }
    })
    this.unSubsribeToRedux = this.$ngRedux.connect((state: RootState) => ({
      promoCode: selectSalePromoCode(state),
    }))(this)
  }

  public $onDestroy() {
    this.unbindPromoAdded()
    this.unSubsribeToRedux()
  }

  /**
   * Toggle the sale promotion popover.
   *
   * @method togglePromotionPopover
   *
   * @param  {Event} event
   *         The DOM event for the click of the promotion link that triggered the toggling of the popover
   */
  public togglePromotionPopover() {
    this.vdPopover.open({
      trigger: this.$element,
      template,
      controller: SalePromotionPopoverController,
      direction: 'left',
    })
  }
}
